<template>
    <div class="container">
        <div class="screen1" ref="screen1"></div>
        <div class="screen2" ref="screen2"></div>
        <div class="screen3" ref="screen3"></div>
    </div>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import { gsap } from "gsap";
export default {
    data() {
        return {
            // 1-3号屏幕
            screenInformationList: [[], [], []],
            // 所有数据
            allInformationList: [],
            // 创建元素的宽度(%)
            elementWidth: 30,
            // 屏幕元素列表
            screenElementList: [],
            // 留言框列表
            messageBoxList: [
                require('./image/message-1.png'),
                require('./image/message-2.png'),
                require('./image/message-3.png')
            ],
            // 特效列表
            effectsList: [
                require('./video/effects-1.webm'),
                require('./video/effects-2.webm'),
                require('./video/effects-3.webm'),
                require('./video/effects-4.webm'),
                require('./video/effects-5.webm'),
                require('./video/effects-6.webm'),
                require('./video/effects-7.webm'),
                require('./video/effects-8.webm'),
                require('./video/effects-9.webm'),
                require('./video/effects-10.webm'),
                require('./video/effects-11.webm'),
                require('./video/effects-12.webm'),
                require('./video/effects-13.webm'),
                require('./video/effects-14.webm'),
                require('./video/effects-15.webm'),
                require('./video/effects-16.webm'),
                require('./video/effects-17.webm'),
                require('./video/effects-18.webm'),
                require('./video/effects-19.webm'),
                require('./video/effects-20.webm'),
                require('./video/effects-21.webm'),
            ],
            // 静止不动播放三遍的特效编号
            effectsNumberList: [1, 2, 3, 7, 8, 9, 13, 14, 15, 16, 17, 18, 19, 20, 21],
            // 随机top最大值和最小值
            randomTopMax: 33.34,
            randomTopMin: 0,
            // duration极值
            durationMax: 20,
            durationMin: 15,
            // 时间间隔
            intervalInformation: 3000,
            intervalAnimation: 4000,
            // timer
            informationTimer: null,
            animationTimer: null,
            // 三个区域分别排序素材上屏 (currentCount值为1，2，3)
            scrollUpList: [
                {
                    left: 1.5,
                    currentCount: 3
                },
                {
                    left: 1.5,
                    currentCount: 3
                },
                {
                    left: 1.5,
                    currentCount: 3
                }
            ],
            spacing: 33.3,
            defaultLeft: 1.5
        }
    },
    mounted() {
        this.screenElementList = [this.$refs.screen1, this.$refs.screen2, this.$refs.screen3,]

        this.informationTimer = setInterval(() => {
            this.getAllInformation()
        }, this.intervalInformation)

        this.animationTimer = setInterval(() => {
            this.runAnimation()
        }, this.intervalAnimation)
    },
    methods: {
        getAllInformation() {
            Axios.get(process.env.VUE_APP_BASE_API + '/getAllInformation').then(request => {
                const informations = request.data.informationList
                informations.forEach(information => {
                    let item = this.allInformationList.find(i => i.id === information.id)
                    if (!item) {
                        this.screenInformationList[information.screenId - 1].push(information)
                    }
                })
                this.allInformationList = informations
            })
        },
        runAnimation() {
            this.screenInformationList.forEach((item, index) => {
                if (item.length > 0) {
                    const firstInformation = item.shift()
                    const ele = this.generateElement(firstInformation, index)
                    this.screenElementList[index].appendChild(ele);
                    this.elementMove(ele, this.screenElementList[index], firstInformation.materialId, firstInformation.effectsNumber)
                } else {
                    if (this.allInformationList.length > 0) {
                        const randomfirstInformation = this.allInformationList[Math.floor(Math.random() * this.allInformationList.length)]
                        const ele = this.generateElement(randomfirstInformation, index)
                        this.screenElementList[index].appendChild(ele);
                        this.elementMove(ele, this.screenElementList[index], randomfirstInformation.materialId, randomfirstInformation.effectsNumber)
                    }
                }
            })
        },
        // 生成元素
        generateElement(o, index) {
            const scrollUp = this.scrollUpList[index]
            if (scrollUp.currentCount >= 3) {
                scrollUp.left = this.defaultLeft
                scrollUp.currentCount = 1
            } else {
                scrollUp.left = scrollUp.left + this.spacing
                scrollUp.currentCount = scrollUp.currentCount + 1
            }
            // 留言
            if (o.materialId === 1) {
                let div = document.createElement("div");  
                // const randomLeft = Math.floor(Math.random() * (100 - this.elementWidth + 1))
                div.style.position = 'absolute'
                div.style.top = '100%'
                div.style.left = this.scrollUpList[index].left + '%'
                div.style.zIndex = 9
                div.style.width = this.elementWidth + '%'
                div.style.aspectRatio = o.messageBackgroundId === 1 ? "800 / 403" : (o.messageBackgroundId === 2 ? '800 / 429' : '800 / 421') // 直接设置 aspect-ratio
                div.style.backgroundImage = `url('${this.messageBoxList[o.messageBackgroundId - 1]}')`;
                div.style.backgroundSize = "100% 100%";
                div.textContent = o.messageContent
                div.style.display = "flex";
                div.style.alignItems = "center";    // 垂直居中
                div.style.justifyContent = "center"; // 水平居中（可选）
                div.style.wordWrap = "break-word";  // 自动换行
                div.style.overflowWrap = "break-word"; // 更现代的换行方式
                div.style.fontSize = screen.width * 0.008 + 'px'; // 直接设置字体大小
                div.style.boxSizing = "border-box";
                // div.style.padding = "2%" 
                div.style.paddingLeft = "2%";
                div.style.paddingRight = "2%";
                div.style.color = o.messageBackgroundId == 2 ? "#00f" : "#fff";
                return div
            }
            // 图片
            if (o.materialId === 2) {
                let img = document.createElement("img");  
                img.src = o.imageUrl
                // const randomLeft = Math.floor(Math.random() * (100 - this.elementWidth + 1))
                img.style.position = 'absolute'
                img.style.top = '100%'
                img.style.left = this.scrollUpList[index].left + '%'
                img.style.zIndex = 8
                img.style.width = this.elementWidth + '%'
                return img
            }
            // webm特效
            if (o.materialId === 3) {
                let video = document.createElement("video");  
                video.src = this.effectsList[o.effectsNumber - 1]
                // const randomLeft = Math.floor(Math.random() * (100 - this.elementWidth + 1))
                video.style.position = 'absolute'
                if (this.effectsNumberList.includes(o.effectsNumber)) {
                    //const randomTop = Math.floor(Math.random() * (this.randomTopMax - this.randomTopMin)) + this.randomTopMin
                    const randomTop = Math.random() > 0.5 ? this.randomTopMax : this.randomTopMin
                    video.style.top = randomTop + '%'
                } else {
                    video.style.top = '100%'
                }
                video.style.left = this.scrollUpList[index].left + '%'
                video.style.zIndex = 7
                video.style.width = window.innerHeight / 3 + 'px'
                video.loop = true
                video.muted = true
                video.autoplay = true
                return video
            }
        },
        // 元素移动
        elementMove(ele, parentEle, materialId, effectsNumber) {
            // 视口宽度
            const viewportWidth = window.innerWidth
            let elementHeight
            // 获取元素高度
            if (materialId === 3) {
                // 特效
                elementHeight = window.innerHeight / 3
            } else if (materialId === 2) {
                // 图片
                elementHeight = viewportWidth / 3 * 0.3 * 3
            } else {
                // 留言
                const rect = ele.getBoundingClientRect();
                elementHeight = rect.height
            }
            
            const yValue = -(window.innerHeight + elementHeight);

            // 随机duration(3-6秒)
            const randomFloat = Math.random() * (this.durationMax - this.durationMin) + this.durationMin;
            let duration = parseFloat(randomFloat.toFixed(2));

            if (materialId === 3 && this.effectsNumberList.includes(effectsNumber)) {
                ele.addEventListener('loadedmetadata', () => {
                    // 使用 GSAP 动画
                    const tween = gsap.to(ele, {
                        duration: ele.duration * 3,       
                        onComplete: () => {
                            parentEle.removeChild(ele);
                            tween.kill();
                        }
                    });
                }, { once: true });
            } else if(materialId === 2) {
                ele.onload = () => {
                    const rect = ele.getBoundingClientRect();
                    let imageHeight = rect.height
                    let imageYValue = -(window.innerHeight + imageHeight);
                    // 使用 GSAP 动画
                    const tween = gsap.to(ele, {
                        duration: duration,       
                        y: imageYValue,           
                        ease: "linear", // 缓动效果
                        onComplete: () => {
                            parentEle.removeChild(ele);
                            tween.kill();
                        }
                    });
                };
            } else {
                // 使用 GSAP 动画
                const tween = gsap.to(ele, {
                    duration: duration,       
                    y: yValue,           
                    ease: "linear", // 缓动效果
                    onComplete: () => {
                        parentEle.removeChild(ele);
                        tween.kill();
                    }
                });
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.informationTimer)
        clearInterval(this.animationTimer)
    }
}
</script>

<style scoped>
.container {
    width: 100%;
    height: 100vh;
    display: flex;
}
.screen1, .screen2, .screen3 {
    width: 33.3333%;
    height: 100%;
    position: relative;
}
</style>